export function IpGuideAndroid() {
  return (
    <div className="space-y-6">
      {/* Step 1 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          1
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            <strong>Einstellungen</strong> öffnen und auf <strong>„WLAN"</strong> oder{" "}
            <strong>„Verbindungen"</strong> tippen.
          </p>
          <svg viewBox="0 0 200 340" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-[190px] mx-auto block" aria-hidden="true">
            {/* Phone frame */}
            <rect x="4" y="4" width="192" height="332" rx="20" fill="#202124" />
            {/* Side buttons */}
            <rect x="196" y="90" width="4" height="50" rx="2" fill="#3a3a3c" />
            <rect x="0" y="80" width="4" height="30" rx="2" fill="#3a3a3c" />
            <rect x="0" y="118" width="4" height="50" rx="2" fill="#3a3a3c" />
            {/* Screen */}
            <rect x="12" y="12" width="176" height="316" rx="14" fill="#fafafa" />
            {/* Status bar */}
            <rect x="12" y="12" width="176" height="24" rx="14" fill="#1a73e8" />
            <rect x="12" y="24" width="176" height="12" fill="#1a73e8" />
            <text x="24" y="28" fontSize="8" fill="#fff">9:41</text>
            <text x="180" y="28" textAnchor="end" fontSize="8" fill="#fff">100%</text>
            {/* App bar */}
            <rect x="12" y="36" width="176" height="40" fill="#1a73e8" />
            <text x="28" y="61" fontSize="16" fill="#fff">←</text>
            <text x="50" y="61" fontSize="13" fontWeight="500" fill="#fff">Einstellungen</text>
            {/* List */}
            <rect x="12" y="76" width="176" height="0.5" fill="#e0e0e0" />
            {/* WLAN row – tapped state */}
            <rect x="12" y="76" width="176" height="52" fill="#e8f0fe" />
            <rect x="20" y="88" width="26" height="26" rx="13" fill="#1a73e8" />
            <text x="33" y="105" textAnchor="middle" fontSize="14" fill="#fff">◈</text>
            <text x="56" y="99" fontSize="14" fill="#202124" fontWeight="500">WLAN</text>
            <text x="56" y="114" fontSize="10.5" fill="#5f6368">ALB-WLAN</text>
            <text x="182" y="106" textAnchor="end" fontSize="18" fill="#5f6368">›</text>
            <rect x="12" y="128" width="176" height="0.5" fill="#e0e0e0" />
            {/* Mobile data */}
            <rect x="12" y="128" width="176" height="52" fill="#fff" />
            <rect x="20" y="140" width="26" height="26" rx="13" fill="#5f6368" />
            <text x="33" y="157" textAnchor="middle" fontSize="13" fill="#fff">▲</text>
            <text x="56" y="156" fontSize="14" fill="#202124">Mobile Daten</text>
            <text x="182" y="158" textAnchor="end" fontSize="18" fill="#5f6368">›</text>
            <rect x="12" y="180" width="176" height="0.5" fill="#e0e0e0" />
            {/* Bluetooth */}
            <rect x="12" y="180" width="176" height="52" fill="#fff" />
            <rect x="20" y="192" width="26" height="26" rx="13" fill="#5f6368" />
            <text x="33" y="209" textAnchor="middle" fontSize="13" fill="#fff">⚡</text>
            <text x="56" y="208" fontSize="14" fill="#202124">Bluetooth</text>
            <text x="182" y="210" textAnchor="end" fontSize="18" fill="#5f6368">›</text>
          </svg>
        </div>
      </div>

      {/* Step 2 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          2
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Auf den Namen des verbundenen Netzwerks tippen.
          </p>
          <svg viewBox="0 0 200 340" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-[190px] mx-auto block" aria-hidden="true">
            {/* Phone */}
            <rect x="4" y="4" width="192" height="332" rx="20" fill="#202124" />
            <rect x="196" y="90" width="4" height="50" rx="2" fill="#3a3a3c" />
            <rect x="12" y="12" width="176" height="316" rx="14" fill="#fafafa" />
            {/* Status + app bar */}
            <rect x="12" y="12" width="176" height="24" rx="14" fill="#1a73e8" />
            <rect x="12" y="24" width="176" height="52" fill="#1a73e8" />
            <text x="24" y="28" fontSize="8" fill="#fff">9:41</text>
            <text x="28" y="60" fontSize="16" fill="#fff">←</text>
            <text x="50" y="60" fontSize="13" fontWeight="500" fill="#fff">WLAN</text>
            {/* WLAN toggle */}
            <rect x="12" y="76" width="176" height="40" fill="#fff" />
            <text x="24" y="100" fontSize="13" fill="#202124">WLAN</text>
            <rect x="162" y="86" width="22" height="13" rx="6.5" fill="#1a73e8" />
            <circle cx="176" cy="92.5" r="6" fill="#fff" />
            <rect x="12" y="116" width="176" height="0.5" fill="#e0e0e0" />
            {/* Connected section */}
            <rect x="12" y="116" width="176" height="20" fill="#f5f5f5" />
            <text x="24" y="130" fontSize="10" fill="#5f6368" fontWeight="600">VERBUNDENES NETZWERK</text>
            <rect x="12" y="136" width="176" height="0.5" fill="#e0e0e0" />
            {/* ALB-WLAN row – highlighted / tapped */}
            <rect x="12" y="136" width="176" height="52" fill="#e8f0fe" />
            <rect x="22" y="148" width="20" height="16" rx="2" fill="none" stroke="#1a73e8" strokeWidth="1.5" />
            <rect x="24" y="158" width="3" height="5" rx="1" fill="#1a73e8" />
            <rect x="29" y="155" width="3" height="8" rx="1" fill="#1a73e8" />
            <rect x="34" y="151" width="3" height="12" rx="1" fill="#1a73e8" />
            <text x="50" y="158" fontSize="13" fill="#202124" fontWeight="500">ALB-WLAN</text>
            <text x="50" y="173" fontSize="10.5" fill="#1a73e8">Verbunden · Internet</text>
            <text x="182" y="165" textAnchor="end" fontSize="18" fill="#1a73e8">›</text>
            <rect x="12" y="188" width="176" height="0.5" fill="#e0e0e0" />
            {/* Other networks */}
            <rect x="12" y="188" width="176" height="20" fill="#f5f5f5" />
            <text x="24" y="202" fontSize="10" fill="#5f6368" fontWeight="600">VERFÜGBARE NETZWERKE</text>
            <rect x="12" y="208" width="176" height="0.5" fill="#e0e0e0" />
            <rect x="12" y="208" width="176" height="44" fill="#fff" />
            <text x="24" y="234" fontSize="12.5" fill="#888">Gäste-WLAN</text>
            {/* Tap ripple */}
            <circle cx="100" cy="162" r="42" fill="rgba(26,115,232,0.1)" />
          </svg>
        </div>
      </div>

      {/* Step 3 */}
      <div className="flex gap-3">
        <span className="shrink-0 w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold flex items-center justify-center mt-0.5">
          3
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-gray-700 mb-3">
            Unter <strong>„IP-Adresse"</strong> steht deine IPv4-Adresse.
            Ggf. erst auf <strong>„Details"</strong> tippen.
          </p>
          <svg viewBox="0 0 200 340" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-[190px] mx-auto block" aria-hidden="true">
            {/* Phone */}
            <rect x="4" y="4" width="192" height="332" rx="20" fill="#202124" />
            <rect x="196" y="90" width="4" height="50" rx="2" fill="#3a3a3c" />
            <rect x="12" y="12" width="176" height="316" rx="14" fill="#fafafa" />
            {/* Status + app bar */}
            <rect x="12" y="12" width="176" height="24" rx="14" fill="#1a73e8" />
            <rect x="12" y="24" width="176" height="52" fill="#1a73e8" />
            <text x="24" y="28" fontSize="8" fill="#fff">9:41</text>
            <text x="28" y="60" fontSize="16" fill="#fff">←</text>
            <text x="50" y="60" fontSize="13" fontWeight="500" fill="#fff">ALB-WLAN</text>
            {/* Details */}
            <rect x="12" y="76" width="176" height="0.5" fill="#e0e0e0" />
            <rect x="12" y="76" width="176" height="40" fill="#fff" />
            <text x="24" y="96" fontSize="11" fill="#5f6368">Netzwerkname</text>
            <text x="24" y="111" fontSize="13" fill="#202124">ALB-WLAN</text>
            <rect x="12" y="116" width="176" height="0.5" fill="#e0e0e0" />
            <rect x="12" y="116" width="176" height="40" fill="#fff" />
            <text x="24" y="136" fontSize="11" fill="#5f6368">Signalstärke</text>
            <text x="24" y="151" fontSize="13" fill="#202124">Sehr gut</text>
            <rect x="12" y="156" width="176" height="0.5" fill="#e0e0e0" />
            {/* IP row – red border */}
            <rect x="12" y="156" width="176" height="46" fill="#fff" />
            <rect x="10" y="154" width="180" height="50" rx="4" fill="none" stroke="#ef4444" strokeWidth="2" />
            <text x="24" y="176" fontSize="11" fill="#5f6368">IP-Adresse</text>
            <text x="24" y="194" fontSize="14" fontWeight="700" fill="#202124">192.168.1.42</text>
            <polygon points="192,175 200,170 200,180" fill="#ef4444" />
            <rect x="12" y="202" width="176" height="0.5" fill="#e0e0e0" />
            <rect x="12" y="202" width="176" height="40" fill="#fff" />
            <text x="24" y="222" fontSize="11" fill="#5f6368">Subnetzmaske</text>
            <text x="24" y="237" fontSize="13" fill="#888">255.255.255.0</text>
            <rect x="12" y="242" width="176" height="0.5" fill="#e0e0e0" />
            <rect x="12" y="242" width="176" height="40" fill="#fff" />
            <text x="24" y="262" fontSize="11" fill="#5f6368">Gateway</text>
            <text x="24" y="277" fontSize="13" fill="#888">192.168.1.1</text>
          </svg>
        </div>
      </div>
    </div>
  );
}
